const campania = process.env.VUE_APP_CAMP || "ofertaAutomotor";

const Facebook = {
  enable() {
    !(function (f, b, e, v, n) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  paso1() {
    if (campania === "ofertaAutomotor") {
      window.fbq("track", "ViewContent", {
        content_type: "Seguro Automotor Web Publica",
        content_name: ""
      });
    }
    if (campania === "ofertaHogar") {
      window.fbq("track", "ViewContent", {
        content_type: "Seguro Hogar Web Publica",
        content_name: "cotizador"
      });
    }
  },
  paso2() {
    if (campania === "ofertaAutomotor") {
      window.fbq("track", "ViewContent", {
        content_type: "Seguro Automotor Web Publica",
        content_name: "patente"
      });
    }
    if (campania === "ofertaHogar") {
      window.fbq("track", "ViewContent", {
        content_type: "Seguro Hogar Web Publica",
        content_name: "datos de vivienda"
      });
    }
  },
  resumen() {
    window.fbq("track", "ViewContent", {
      content_type: "Seguro Automotor Web Publica",
      content_name: "datos"
    });
  },
  condicion() {
    window.fbq("track", "Search", {
      content_type: "Seguro Automotor Web Publica",
      content_name: ""
    });
  },
  marca() {
    window.fbq("track", "Search", {
      content_type: "Seguro Automotor Web Publica",
      content_name: "marca"
    });
  },
  modelo() {
    window.fbq("track", "CompleteRegistration", {
      content_type: "Seguro Automotor Web Publica",
      content_name: ""
    });
  },
  version() {
    window.fbq("track", "CompleteRegistration", {
      content_type: "Seguro Automotor Web Publica",
      content_name: "version"
    });
  },
  gnc() {
    window.fbq("track", "AddToCart", {
      content_type: "Seguro Automotor Web Publica",
      content_name: ""
    });
  },
  guardado() {
    window.fbq("track", "AddToCart", {
      content_type: "Seguro Automotor Web Publica",
      content_name: "lugar"
    });
  },
  cotizacion_planes() {
    window.fbq("track", "Purchase", {
      content_type: "Seguro Automotor Web Publica",
      content_name: ""
    });
  },
  paso3() {
    window.fbq("track", "Search", {
      content_type: "Seguro Hogar Web Publica",
      content_name: "cobertura"
    });
  },
  paso4() {
    window.fbq("track", "AddToCart", {
      content_type: "Seguro Hogar Web Publica",
      content_name: "adicionales"
    });
  }
};

export default Facebook;
